<div
    tabindex="-1"
    id="myModal"
    role="dialog"
    class="modal fade in">
    <div class="backdrop"></div>
    <!-- Modal Dialog starts here -->
    <div
        data-show="true"
        role="document"
        class="modal-dialog"
        [class]="modalSize">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title">{{title}}</h3>
            </div>
            <div class="modal-body">
                <div class="well">{{message}}</div>
            </div>
            <div class="modal-footer">
                <div class="form-group">
                    <button
                        type="button"
                        class="btn btn-default nlr-btn-sm"
                        (click)="close()">
                        OK
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
